import { v4 as uuid } from 'uuid';
import ComponentsType from '../Component/ComponentType';

/**
 * Cria um nó com id aleátorio
 * @param {*} componentType
 * @param {*} x posição na horizontal
 * @param {*} y posição na vertical
 */
export const createNode = (componentType, x, y) => {
  const id = `node_${uuid()}`;
  const node = {
    id,
    position: { x, y },
    type: 'NodeFlow',
    data: {
      label: '',
      id,
      typeElement: componentType,
    },
  };

  return node;
};

/**
 * Cria um vertice com id aleátorio
 * @param {*} source id do nó de origem
 * @param {*} target id do nó de destino
 * @returns
 */
export const createEdge = (source, target) => ({
  id: `edge_${uuid()}`,
  arrowHeadType: 'arrowclosed',
  source,
  target,
  type: 'smoothstep',
  targetHandle: 'targetHandleTop',
  sourceHandle: 'sourceHandle',
});

/** Adiciona um novo nó fluxo.
 *
 * Pode ser adicionado um vertice, passado em edge.
 * Se o nó origem desse vertice tiver algum proximo nó (next),
 * então é criado um outro vertice para conectar o novo nó ao proximo nó do nó de origem.
 * Isso é feito para manter o fluxo como uma sequência de nós
 * @param {*} flow
 * @param {*} node
 * @param {*} edge
 * @returns fluxo atualizado
 */
export const addNodeFlow = (flow, node, edge) => {
  const newNode = node;
  const flowToReturn = flow;
  flowToReturn[newNode.id] = newNode;

  if (edge) {
    let newEdge = edge;
    const nodeFrom = flowToReturn[newEdge.source];
    if (nodeFrom.data.typeElement.id === ComponentsType.INICIO.id) newEdge.targetHandle = 'targetHandle';

    newEdge.id = `edge_${uuid()}`;
    newEdge.target = newNode.id;
    flowToReturn[newEdge.id] = { ...newEdge };

    if (nodeFrom.next) {
      newEdge = createEdge(newNode.id, nodeFrom.next, uuid());
      flowToReturn[newEdge.id] = { ...newEdge };
      newNode.next = nodeFrom.next;

      Object.keys(flowToReturn).forEach((key) => {
        if (flowToReturn[key].type === 'smoothstep'
          && flowToReturn[key].source === nodeFrom.id
          && flowToReturn[key].target === nodeFrom.next) {
          delete flowToReturn[key];
        }
      });
    }
    nodeFrom.next = newNode.id;
  }

  return flowToReturn;
};
